(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rejuvapath-cart"] && !Shopify.designMode) return;
  try {
    
  function initializeRejuvaPathCarts() {
    document.querySelectorAll('[data-rp-cart]').forEach((section) => {
      if (section.dataset.rpCartInitialized) return;
      section.dataset.rpCartInitialized = 'true';
      const form = section.querySelector('[data-rp-cart-form]');
      if (!form) return;
      const updateButton = form.querySelector('[data-rp-cart-update]');
      const status = form.querySelector('[data-rp-cart-status]');
      form.querySelectorAll('[data-rp-cart-quantity]').forEach((control) => {
        const input = control.querySelector('[data-rp-cart-input]');
        const buttons = [...control.querySelectorAll('[data-rp-cart-step]')];
        if (!input) return;
        const updateControls = () => {
          const minimum = Number(input.min) || 1;
          const maximum = input.max ? Number(input.max) : Infinity;
          const current = Number(input.value);
          buttons.forEach((button) => {
            button.hidden = false;
            button.disabled = input.readOnly || (Number(button.dataset.rpCartStep) < 0 ? current <= minimum : current >= maximum);
          });
        };
        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            if (input.readOnly || form.getAttribute('aria-busy') === 'true') return;
            const minimum = Number(input.min) || 1;
            const maximum = input.max ? Number(input.max) : Infinity;
            const step = Number(input.step) || 1;
            const current = Number(input.value) || minimum;
            input.value = String(Math.min(maximum, Math.max(minimum, current + Number(button.dataset.rpCartStep) * step)));
            updateControls();
            form.requestSubmit(updateButton);
          });
        });
        input.addEventListener('input', updateControls);
        updateControls();
      });
      form.addEventListener('submit', (event) => {
        form.setAttribute('aria-busy', 'true');
        if (event.submitter === updateButton && status) status.textContent = status.dataset.updating;
      });
    });
  }
  initializeRejuvaPathCarts();
  document.addEventListener('shopify:section:load', initializeRejuvaPathCarts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rejuvapath-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rp-guide]').forEach((section) => {
    const videos = [...section.querySelectorAll('video')];
    videos.forEach((activeVideo) => {
      activeVideo.addEventListener('play', () => {
        videos.forEach((video) => {
          if (video !== activeVideo) video.pause();
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rejuvapath-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.rp-chrome-mobile-nav a');
    if (link) link.closest('details').removeAttribute('open');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.rp-chrome-menu[open]').forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary').focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rejuvapath-product"] && !Shopify.designMode) return;
  try {
    
  function initializeRejuvaPathProducts(scope) {
    const sections = scope.matches?.('[data-rp-product-section]') ? [scope] : scope.querySelectorAll('[data-rp-product-section]');
    sections.forEach((section) => {
      if (section.dataset.rpInitialized === 'true') return;
      section.dataset.rpInitialized = 'true';
      const thumbnails = [...section.querySelectorAll('[data-rp-image-target]')];
      const panels = [...section.querySelectorAll('[data-rp-image-panel]')];
      const updateImage = (button) => {
        thumbnails.forEach((thumbnail) => thumbnail.setAttribute('aria-pressed', String(thumbnail === button)));
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.rpImagePanel !== button.dataset.rpImageTarget;
          if (panel.hidden) {
            panel.querySelectorAll('video').forEach((video) => video.pause());
            panel.querySelectorAll('iframe').forEach((frame) => { const source = frame.getAttribute('src'); if (source) frame.setAttribute('src', source); });
          }
        });
      };
      const showImage = (button) => {
        if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) { document.startViewTransition(() => updateImage(button)); }
        else { updateImage(button); }
      };
      thumbnails.forEach((button, index) => {
        button.addEventListener('click', () => showImage(button));
        button.addEventListener('keydown', (event) => {
          let nextIndex;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % thumbnails.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + thumbnails.length) % thumbnails.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = thumbnails.length - 1;
          if (nextIndex === undefined) return;
          event.preventDefault();
          showImage(thumbnails[nextIndex]);
          thumbnails[nextIndex].focus();
        });
      });
      const quantityInput = section.querySelector('[data-rp-quantity]');
      const quantityButtons = [...section.querySelectorAll('[data-rp-quantity-step]')];
      const updateQuantityButtons = () => {
        if (!quantityInput) return;
        const minimum = Number(quantityInput.min) || 1;
        const maximum = quantityInput.max ? Number(quantityInput.max) : Infinity;
        const current = Number(quantityInput.value) || minimum;
        quantityButtons.forEach((button) => {
          button.disabled = Number(button.dataset.rpQuantityStep) < 0 ? current <= minimum : current >= maximum;
        });
      };
      quantityButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!quantityInput) return;
          const minimum = Number(quantityInput.min) || 1;
          const maximum = quantityInput.max ? Number(quantityInput.max) : Infinity;
          const increment = Number(quantityInput.step) || 1;
          const current = Number(quantityInput.value) || minimum;
          quantityInput.value = String(Math.min(maximum, Math.max(minimum, current + Number(button.dataset.rpQuantityStep) * increment)));
          quantityInput.dispatchEvent(new Event('change', { bubbles:true }));
          updateQuantityButtons();
        });
      });
      quantityInput?.addEventListener('change', updateQuantityButtons);
      updateQuantityButtons();
      section.querySelector('[data-rp-variant-select]')?.addEventListener('change', (event) => {
        const destination = new URL(window.location.href);
        destination.searchParams.set('variant', event.target.value);
        window.location.assign(destination.toString());
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', () => initializeRejuvaPathProducts(document)); }
  else { initializeRejuvaPathProducts(document); }
  document.addEventListener('shopify:section:load', (event) => initializeRejuvaPathProducts(event.target));

  } catch(e) { console.error(e); }
})();
})();
